// extracted by mini-css-extract-plugin
export default {"favorite":"styles_favorite__LVBIy"};